import { ROUTE_TEXT_MATERIALS_CATEGORIES_ADD } from '@@partner:config/routes'
import { useFetchAllTextMaterialCategories } from '@@partner:graphql/query/textMaterial/categories/allTextMaterialCategories.gql'
import TextMaterialCategoriesTable from '@components/textMaterials/category/grid/TextMaterialCategoriesTable'
import TextMaterialsTopMenu from '@components/textMaterials/TextMaterialsTopMenu'
import React from 'react'
import { AddOutline } from 'react-ionicons'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import { Nav, Navbar, Panel } from 'rsuite'


export default function TextMaterialCategoriesPage () {
  const { brandSlug } = useParams<any>()
  
  const { data, loading, error } = useFetchAllTextMaterialCategories()

  return (
    <div>
      <h1 className="u-heading">Категории контента</h1>
      <TextMaterialsTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_CATEGORIES_ADD, {
              brandSlug
            })}
          >
             Добавить категорию
          </Nav.Item>
        </Nav>
      </Navbar>

      <Panel shaded>
        { data?.allTextMaterialCategories && (
          <TextMaterialCategoriesTable 
            brandSlug={brandSlug}
            textMaterialCategories={data?.allTextMaterialCategories}
            loading={loading}
          />
        )}
      </Panel>
    </div>
  )
}